import React, { memo } from "react";
import ReactHtmlParser from "react-html-parser";
import DoubleHeading from "./double-heading";
import LazyLoad from "react-lazyload";

const Features = memo(({ feature_title, features }) => {
  return (
    <div className="">
      <LazyLoad once={true}>
        <>
          {features && (
            <DoubleHeading
              text={
                feature_title && feature_title.length > 2
                  ? feature_title
                  : "Features"
              }
            />
          )}
          {features && (
            <div className="sm:mt-5 mt-4 paddingX-50 mb-5 ck-content">
              <p
                className="bg-white text-base ck-content"
                style={{ whiteSpace: "pre-wrap" }}
                dangerouslySetInnerHTML={{ __html: ReactHtmlParser(features) }}
              ></p>
            </div>
          )}
        </>
      </LazyLoad>
    </div>
  );
});

export default Features;
